
export const language = {
    general: {
        error: 'Something went wrong. Please try again.',
      exit: "to go out",
      welcome: "Welcome",
      or: "or",
      and: "It is",
      from: "in",
      partner: "partner",
      fromAssitive: "from Assistive.",
      signin: "To enter",
      terms: "terms of use",
      policy: "Privacy Policy",
      resend: "Resend",
      needHelp: "Need help?",
      helpCenterText: "Visit our center to access additional information about installation and best usage practices.",
      helpCenter: "Help Center",
      loading: "loading",
      close: "Close",
      typeToSearch: "Type to search…",
      noResults: "No results",
      domain: "Domain",
      action: "Actions",
      active: "Activate",
      inactive: "Disable",
      delete: "delete",
      pagingMessage_one: "Showing {{param1}} to {{param2}} of {{param3}} row",
      pagingMessage_other: "Showing {{param1}} to {{param2}} of {{param3}} rows",
      badges: {
        active: 'Active',
        expired: 'Expired',
        grace: 'Grace',
        trial: 'Trial',
        incomplete: 'Pending payment',
        provisioning: 'Provisioning',
        suspended: 'Suspended',
        cancelled: 'Cancelled',
        disabled: 'Disabled'
      },
      clipboard: {
        copied: 'Copied to clipboard',
        error: 'Failed to copy'
      }
    },
    footer:{
        rights:"All rights reserved.",
        terms:"Terms of use",
        privacy:"Privacy Policy",
        partner:"Be a partner",
        help:"Help Center",
        version:"Version"
    },
    menu: {
      home: "Start",
      report: "Reports",
      perfil: "Profile",
      hidMenu: "Hide menu",
      showMenu: "View menu",
      addSite: "Add new website",
      peopleUnique: "Because people are unique...",
      activeSite:'active site',
      activeSites:'active sites'
    },
    navbar: {
        homePage: 'Home page',
        expandMenu: 'Expand side menu',
        noDomain: 'No domain registered',
        siteSearchPlaceholder: 'Type to search…',
        siteSearchNoResults: 'No domain found',
        userDropdown: {
            trialPlan: 'Free Trial',
            defaultPlan: 'Current Plan',
            profile: 'Profile',
            account: 'Account',
            logout: 'Logout'
        }
    },
    verticalMenu: {
      sites: "Websites",
      dashboard: "Dashboard",
      installation: "Installation",
      aiContent: "AI Content",
      alternativetexts: "Alternative Texts",
      socialimages: "Social Images",
      aicontentreview: "AI Content Review"
    },
    form: {
      user: "User",
      password: "Password",
      login: "To enter"
    },
    home: {
      greetings: "Welcome to the system"
    },
    views: {
      aiContent: {
        alternativeTexts: {
          title: "Alternative Texts",
          subtitle: "Manage and improve image alternative texts across your website.",
          globalAlert: {
            title: "No images found yet:",
            description: "We are collecting images from your site."
          },
          generateAllButton: "Generate ALT with AI",
          generateAllModal: {
            title: "Bulk generate ALT",
            body: "This command runs AI on all images without description in the current domain. Approved/ignored images are skipped.",
            comingSoon: "Coming in phase 5c."
          },
          tabs: {
            all: "All",
            catalogued: "Without ALT",
            aiGenerated: "AI suggested",
            needsReview: "Needs review",
            approved: "Approved",
            ignored: "Ignored"
          },
          sortBy: {
            label: "Sort by",
            placeholder: "Sort by score…",
            recent: "Updated (recent)",
            oldest: "Updated (oldest)",
            alphaAsc: "A → Z",
            alphaDesc: "Z → A",
            scoreAsc: "Score (lowest first)",
            scoreDesc: "Score (highest first)"
          },
          bulk: {
            selected: "{{count}} selected",
            approve: "Approve",
            ignore: "Ignore",
            clear: "Clear selection",
            selectAll: "Select all",
            selectRow: "Select row",
            success: "{{count}} items updated",
            partial: "{{ok}} of {{total}} updated (rest failed)"
          },
          scoreCard: {
            title: "Accessibility Report",
            computing: "Scoring this alt with AI…",
            recalculating: "Updating score…",
            notScoredYet: "This alt has not been scored yet. Score is computed automatically after editing, approving or regenerating.",
            confidence: "AI confidence",
            readingTime: "Estimated reading time: {{seconds}}s",
            levels: {
              excellent: "Excellent",
              good: "Good",
              fair: "Fair",
              poor: "Poor"
            },
            confidenceLevels: {
              high: "High",
              medium: "Medium",
              low: "Low"
            },
            dimensions: {
              subject: "Subject",
              action: "Action",
              context: "Context",
              objects: "Objects",
              clarity: "Clarity",
              size: "Length",
              wcag: "WCAG compliance",
              redundancy: "No redundancy"
            }
          },
          historyAccordion: {
            title: "Version history",
            empty: "No previous changes.",
            restore: "Restore",
            previousScore: "Previous score: {{score}}"
          },
          filters: {
            pageUrl: "Page URL",
            pageUrlPlaceholder: "Search by URL, file or alt…",
            status: "Status",
            source: "Source",
            fileType: "File Type",
            all: "All formats",
            // Redesign — 5 filters
            sitePlaceholder: "All sites",
            pagePlaceholder: "All pages",
            pageSearchPlaceholder: "Type to search…",
            allPages: "All pages",
            noPages: "No pages found",
            textSourceLabel: "Text source",
            textSourceAll: "All sources",
            reviewLabel: "Review",
            reviewAll: "All reviews",
            reviewReviewed: "Reviewed",
            reviewNotReviewed: "Not reviewed",
            reviewIgnored: "Ignored",
            activityLabel: "Image status",
            activityAll: "All statuses",
            activityActive: "Active on site",
            activityRemoved: "Removed from site",
            fileTypeLabel: "File type",
            fileTypeAll: "All formats",
            more: "More filters",
            clear: "Clear filters",
            contentChanged: "Image changed",
            scanTitle: "Verify images now",
            scanSubtitle: "Detect content changes",
            scanRunning: "Verifying...",
            scanTooltip: "Deep scan for content changes in images."
          },
          badges: {
            contentChanged: "Image changed",
            contentChangedTooltip: "We detected that the image on the client's site is different from the one that was described/approved. The current text may no longer match what users see. Review and update if needed."
          },
          statuses: {
            all: "All",
            catalogued: "No AI description",
            "ai-generated": "AI description",
            edited: "Edited",
            approved: "Approved",
            ignored: "Ignored"
          },
          sources: {
            all: "All sources",
            human: "Dev",
            ai: "AI",
            edited: "Curation"
          },
          cards: {
            total: "Total images",
            totalSubtitle: "Across {{pages}} pages",
            withAlt: "With alt text (in use)",
            aiGeneratedField: "Generated by AI",
            humanReviewed: "Reviewed by human",
            pending: "Not reviewed (pending)",
            percentOfTotal: "{{percent}}% of total",
            // Legacy — remove once old front is fully off
            missing: "Without ALT",
            aiGenerated: "AI suggestions",
            needsReview: "Needs review",
            approved: "Approved",
            ignored: "Ignored"
          },
          table: {
            url: "Page",
            image: "Image",
            fileName: "File name",
            altOriginal: "Original alt text",
            altCurrent: "Current alt",
            altInUse: "Current alt text",
            textSource: "Text source",
            review: "Review",
            scoreIA: "AI Score",
            pageUrl: "Page / URL",
            detectedAt: "Detected at",
            status: "Status",
            score: "Score",
            actions: "Actions",
            noResults: "No images found.",
            resultsCount: "{{from}}-{{to}} of {{total}}",
            rowsPerPage: "Rows per page"
          },
          textSource: {
            dev: "Dev",
            ai: "AI",
            aiEngine: "AI ({{engine}})",
            manual: "Curation"
          },
          review: {
            by: "Reviewed by {{name}}",
            approvedBy: "Approved by {{name}}",
            savedBy: "Saved by {{name}}",
            editedBy: "Reviewed by {{name}}",
            ignoredBy: "Ignored by {{name}}",
            none: "Not reviewed"
          },
          scoreLabel: {
            excellent: "Excellent",
            good: "Good",
            regular: "Fair",
            weak: "Poor",
            na: "N/A"
          },
          actions: {
            menu: "More actions",
            edit: "Edit",
            approve: "Approve",
            regenerate: "Regenerate",
            ignore: "Ignore",
            unignore: "Undo ignore"
          },
          sidePanel: {
            details: "Details",
            currentAltLabel: "Current alt",
            empty: "—",
            domain: "Domain",
            firstSeen: "First seen at",
            lastSeen: "Last seen at",
            savedBy: "Saved by",
            approvedByLabel: "Approved by",
            imageChangedBannerTitle: "Image changed",
            imageChangedBannerBody: "This image was replaced on the site after the current description was set. The text may no longer describe what users see — review and update if needed.",
            keepApprovedButton: "Keep approved",
            keepApprovedHint: "or use Edit / Regenerate below to change the text",
            pageViews: "Page views",
            editButton: "Edit",
            cancelEdit: "Cancel",
            saveEdit: "Save",
            useAiSuggestion: "Use this suggestion",
            regenerate: "Regenerate",
            generateWithAi: "Generate with AI",
            regenerating: "Generating new alt with AI…",
            regeneratingShort: "Regenerating…",
            generating: "Generating…",
            approving: "Approving…",
            regenerateSuccess: "New alt generated by AI",
            regenerateTimeout: "AI is taking longer than expected. Try again shortly.",
            regenerateConfirmTitle: "Regenerate with AI?",
            regenerateConfirmBody: "This will discard the text you approved and generate a new one with AI. If the new score falls below the threshold, the image goes back to 'Needs review'. Continue?",
            regenerateConfirmAction: "Regenerate",
            aiGeneratedAgo: "Generated {{time}}",
            charCount: "{{count}} characters",
            approveButton: "Approve",
            saveEditButton: "Approve",
            savingEdit: "Approving…",
            approveConfirmTitle: "Approve this text?",
            ignoreConfirmTitle: "Ignore this image?",
            ignoreConfirmBody: "The image will be marked as decorative. Screen readers will skip it, announcing nothing. You can revert anytime.",
            ignoreConfirmConfirm: "Yes, ignore",
            ignoreConfirmCancel: "Cancel",
            ignoreButton: "Ignore (decorative)",
            unignoreButton: "Undo ignore",
            ignoredBadge: "Image ignored — screen reader skips it",
            editedBy: "Edited by {{user}}",
            editedAt: "on {{date}}",
            approvedByAt: "Approved by {{user}} on {{date}}",
            saveSuccess: "ALT saved",
            approveSuccess: "ALT approved",
            ignoreSuccess: "Image marked as decorative",
            unignoreSuccess: "Image back in the flow",
            useSuggestionSuccess: "AI suggestion applied",
            editPlaceholder: "Type the alt text for this image",
            sourceBadge: {
              ai: "AI suggested",
              edited: "Manually edited",
              approved: "Approved",
              original: "Original alt",
              none: "No description"
            },
            approval: {
              emptyDevAlertBody: "The image has no alt text. Providing a description is recommended.",
              originalTitle: "Original alt text",
              originalNotProvided: "Not provided",
              originalCodeLabel: "Detected in code:",
              aiSuggestedTitle: "Current alt text",
              aiSourceLabel: "Source:",
              aiSourceEngine: "AI ({{engine}})",
              aiSourceGeneric: "AI",
              curatorshipSource: "Curation",
              devSource: "Dev",
              approvedChip: "Approved",
              reviewedChip: "Reviewed",
              aiSuggestionTitle: "AI suggestion",
              aiSuggestionPlaceholder: "On demand: generate an AI suggestion to compare with the current text.",
              aiSuggestionLoading: "Generating AI suggestion…",
              aiSuggestionError: "Could not generate the suggestion.",
              aiSuggestionRetry: "Try again",
              useSuggestion: "Use this suggestion",
              generateSuggestion: "Generate suggestion with AI",
              saveChanges: "Save changes",
              cancel: "Cancel",
              aiSuggestedInfo: "This text was automatically generated by AI. Review and approve if appropriate.",
              pendingBadge: "Pending approval",
              editButton: "Edit text",
              approveHint: "Once approved, this text will be used on the site.",
              saveChangesButton: "Save changes",
              savingChanges: "Saving…"
            }
          }
        }
      },
      login: {
        title: "Hello!",
        subtitle: "Log in to manage your digital accessibility journey.",
        email: "Your email",
        password: "Your password",
        forgotPassword: "Forgot password?",
        remember: "Keep logged in",
        newAccount: "start a free trial",
        newPlatform: "New here?",
        error: "Sorry, but something went wrong. ",
        loggedSuccessPartA: "You have successfully connected as a",
        loggedSuccessPartB: "User for Assistive. ",
        invalidLengthPass: "The password must be at least 8 characters long.",
        invalidEmail: "Enter a valid email e.g. \"email@mail.com\"",
      },
      register: {
        title: "Start your 7-day free trial now!",
        subtitle: "No need to register a credit card",
        email: "Your email",
        emailPlaceHold: "Email (required)",
        password: "Password",
        name: "What is your name?",
        namePlaceHold: "Name (required)",
        partnerPartA: "I want to be one",
        partnerPartB: "from Assistive.",
        start: "Start now",
        agree: "By creating my account I agree to the",
        haveAccount: "Already have an account?"
      },

      reset: {
        title: "authentication code",
        subtitle: "An email with the authentication code was sent to:",
        code: "Enter the 6-digit code",
        valid: "Validate",
        codeSpan: "Didn't receive the code?"
      },
      forgot: {
        title: "Forgot password?",
        subtitle: "Enter your registration email and we will send you instructions to reset your password.",
        sendInfo: "Send information",
        backLogin: "Back to login",
        sentTitle: "Instructions sent!",
        sentSubtitle: "We have just sent you an email with instructions for resetting your password."
      },
      installation: {
        viewCode: "View installation code",
        modalSendEmails: {
          title: 'Send instructions by email',
          description: 'To include more than one email address, simply separate them with a comma.',
          emailLabel: 'Email',
          emailPlaceholder: 'email address.',
          invalidEmails: 'one or more emails are invalid!',
          sendButton: 'Send instructions',
          successToast: 'Code sent to emails successfully'
        },
        wizard: {
          back: 'Back',
          next: 'Next',
          steps: {
            method: 'Method',
            personalize: 'Personalize',
            whitelabel: 'Brand',
            generate: 'Generate',
          },
          step1: {
            title: 'How would you like to install the widget?',
            subtitle: 'Choose between a quick installation or personalize it visually before generating the script.',
            quickTitle: 'Quick installation',
            quickDesc: 'Use the default script and install the widget in a few clicks.',
            quickBtn: 'Use quick script',
            quickFeature1: 'Fast and simple',
            quickFeature2: 'Ideal for basic configuration',
            quickFeature3: 'Recommended for simple plans',
            configTitle: 'Personalized installation',
            configDesc: 'Visually customize the widget, generate a unique script and share.',
            configBtn: 'Personalize widget',
            configFeature1: 'Full visual personalization',
            configFeature2: 'Desktop, mobile and advanced options',
            configFeature3: 'Generate JSON to reuse',
            tip: 'Tip: you can change all settings at any time.',
          },
          step2: {
            title: 'Personalize widget',
            subtitle: 'Personalize the appearance, buttons and position of the widget. Settings are applied separately for desktop and mobile.',
            configuringFor: 'Configuring for:',
            configTipPrefix: 'All settings on this screen apply to',
            preview: 'Preview',
            previewHintOpen: 'Click the button to open the widget',
            previewHintClose: 'Click × to close',
            tabs: {
              appearance: 'Appearance',
              buttons: 'Buttons',
              position: 'Position',
            },
            appearanceDesc: 'Personalize the visual of the trigger button.',
            triggerLabel: 'Button (trigger)',
            btnShape: 'Button shape',
            btnSize: 'Button size',
            btnIcon: 'Button icon',
            colorsLabel: 'Colors',
            resetColors: 'Reset',
            btnColor: 'Button color',
            bodyColor: 'Window color',
            colorSolid: 'Solid',
            colorOpacity: 'Opacity',
            shapes: {
              circle: 'Circle',
              square: 'Square',
              rounded: 'Rounded',
            },
            sizes: {
              small: 'Small',
              medium: 'Medium',
              large: 'Large',
            },
            icons: {
              default: 'Default',
              config: 'Config',
              gear: 'Gear',
              font: 'Font',
            },
            buttonsDesc: 'Enable or disable the buttons displayed in the widget.',
            activeButtons: '{{active}} of {{total}} active buttons',
            buttons: {
              textsize: { label: 'Larger text', desc: 'Increases the text size on the page' },
              font: { label: 'Change font', desc: 'Changes the font to improve readability' },
              align: { label: 'Text alignment', desc: 'Adjusts text alignment' },
              linespacing: { label: 'Line spacing', desc: 'Adjusts the spacing between lines' },
              charspacing: { label: 'Letter spacing', desc: 'Adjusts the spacing between letters' },
              image: { label: 'No images', desc: 'Removes images from the page' },
              semantic: { label: 'Semantic Dictionary', desc: 'Displays semantic definitions of words' },
              smartcontrast: { label: 'Text contrast', desc: 'Adjusts the contrast of texts' },
              contrast: { label: 'Page contrast', desc: 'Adjusts the contrast of the entire page' },
              saturation: { label: 'Color intensity', desc: 'Adjusts color saturation' },
              colors: { label: 'Page colors', desc: 'Adjusts page colors' },
              readaloud: { label: 'Site reader', desc: 'Reads the page content aloud' },
              magnifying: { label: 'Magnifier', desc: 'Magnifies areas of the page' },
              focus: { label: 'Focus highlight', desc: 'Highlights the element focused by the keyboard' },
              highlight: { label: 'Highlight elements', desc: 'Highlights links, buttons and titles' },
              cursor: { label: 'Cursor', desc: 'Enlarges the mouse cursor' },
              guide: { label: 'Reading guide', desc: 'Visual guide to follow while reading' },
              ruler: { label: 'Reading ruler', desc: 'Ruler to follow while reading' },
              tooltips: { label: 'Show descriptions', desc: 'Displays descriptions on hover' },
              animation: { label: 'Stop animations', desc: 'Removes animations from the page' },
              sound: { label: 'No sound', desc: 'Disables page sounds' },
              struct: { label: 'Page structure', desc: 'Displays the navigation structure' },
              pdf: { label: 'PDF accessibility', desc: 'Adds accessibility to PDFs' },
              vlibras: { label: 'VLibras', desc: 'Translation to Brazilian Sign Language', tooltip: 'This feature is provided by the VLibras project of the Brazilian Federal Government.' },
            },
            btnCategories: {
              content: 'Content',
              colors: 'Color and screen',
              navigation: 'Navigation',
              libras: 'Sign language',
              features: 'Additional features',
            },
            libras: {
              signsHumanActive: 'Enable support with a human interpreter',
              signsHumanDesc: 'Enterprise plan exclusive.',
              signsHumanUrl: 'Support URL (video call)',
              wlHumanSignsImgUri: 'Interpreter photo URL',
            },
            widgetPreview: {
              language: 'English',
              reset: 'Reset',
              selectProfile: 'Select usage profiles',
              improveExperience: 'Improve your experience',
              home: 'Home',
              help: 'Help',
              openWidget: 'Open widget',
              closeWidget: 'Close widget',
              minimizeWidget: 'Minimize widget',
              widgetOpenedAnnounce: 'Accessibility widget opened. Press Tab to reach the close button.',
              widgetDialogLabel: 'Assistive accessibility widget',
              libras: 'Libras',
              librasHumanTitle: 'Sign language support',
              librasHumanSubtitle: 'Support within 5 minutes.',
              librasHumanDesc: 'Get help from a sign language interpreter while browsing.',
              librasRequest: 'Request support',
              librasChoiceTitle: 'Available resources',
              librasChoiceSubtitle: 'Choose the resource you want to use.',
              librasAutoTitle: 'Automatic translation',
              librasAutoTag: 'External resource',
              librasAutoDesc: 'Automatically translates the page content to Libras with the VLibras avatar.',
              librasActivate: 'Activate VLibras',
            },
            positionDesc: 'Choose where the widget button will be displayed.',
            horizontal: 'Horizontal',
            left: 'Left',
            right: 'Right',
            vertical: 'Vertical',
            top: 'Top',
            center: 'Center',
            bottom: 'Bottom',
            offsets: 'Offsets (distance from selected edge)',
            hOffset: 'Horizontal offset',
            vOffset: 'Vertical offset',
            offsetHint: 'Offset is the distance between the button and the screen edge.',
          },
          step3wl: {
            title: 'Brand',
            subtitle: 'Customize the widget with your brand. Enterprise plan exclusive.',
            previewingOn: 'Previewing on:',
            configTip: 'These settings apply to both Desktop and Mobile.',
            brandSection: 'Your brand (white label)',
            wlName: 'Brand name',
            wlNamePlaceholder: 'Your brand',
            wlEmail: 'Contact email',
            wlLogoUri: 'Logo URL',
            wlLogoLinkUri: 'Logo link (brand website)',
            wlStatementUri: 'Accessibility statement URL',
          },
          step3: {
            title: 'Generate installation code',
            subtitle: 'Copy the script and paste it before the closing </body> tag on your website.',
            tabScript: 'Inline script',
            tabJson: 'Configuration JSON',
            copy: 'Copy code',
            copied: 'Copied!',
            sendEmail: 'Send by email',
          },
        }
      },
      sites: {
        mySites: "My websites",
        noSite: "You haven't registered any website yet.",
        addNow: "Add now",
        plan: "Plan",
        domain: "Domains",
        all: "all",
        inactive: "inactive",
        actives: "active",
        addSite: "Add Website",
        updatedSite: "Updating website",
        code: "View installation code",
        search: "Search",
        
        planStatus: {
          trial: {
            daysRemaining: '{{days}} days remaining to end your free trial',
            hoursRemaining: '{{hours}} hours remaining to end your free trial',
            expired: 'Your trial period has ended, activate your license to continue using'
          },
          active: {
            renewal: 'Automatic renewal on {{date}}.',
            renewalDays: 'Automatic renewal in {{days}} days.'
          },
          expired: 'Your plan expired on {{date}}',
          grace: 'Your plan is in grace period and will be deactivated on {{date}}',
          cancelled: 'Your plan is active until {{date}}'
        },
        planDescription: {
          free: 'For companies with up to 10 employees, subject to analysis.',
          essential: 'For companies with sites with low access volume. Only 1 (one) domain.',
          advanced: 'Plan up to 10,000 page views. For companies with intermediate access volume and more than one domain. Up to 2 (two) domains.',
          enterprise: 'Plan with unlimited page views. For companies with high access volume that require managed and personalized services.'
        },
        actions: {
          activateLicense: 'Activate license',
          promotionalCode: 'Promotional code',
          updatePlan: 'Update plan',
          completePlan: 'Complete payment',
          cancelPlan: 'Cancel plan',
          revertCancellation: 'Revert cancellation'
        },
        trialLabel: 'TRIAL',
        modalCode: {
          description: 'Copy the code below and deploy it to your domain',
          copyButton: 'Copy Code',
          customInstallButton: 'Custom installation'
        }
      },
      dashboard: {
        header: {
          title: 'Dashboard'
        },
        periods: {
          lastMonth: 'Last month',
          threeMonths: '3 months',
          twelveMonths: '12 months'
        },
        export: {
          button: 'Export',
          loading: 'Exporting...',
          error: 'Could not export. Please try again.'
        },
        months: {
          jan: 'Jan',
          fev: 'Feb',
          mar: 'Mar',
          abr: 'Apr',
          mai: 'May',
          jun: 'Jun',
          jul: 'Jul',
          ago: 'Aug',
          set: 'Sep',
          out: 'Oct',
          nov: 'Nov',
          dez: 'Dec'
        },
        globalAlert: {
          title: 'No usage data yet:',
          description: 'We are collecting usage information to update the dashboard.'
        },
        topMetrics: {
          pageViews: {
            title: 'Page Views',
            subtitle: 'Total page views'
          },
          pluginOpens: {
            title: 'Plugin Opens',
            subtitle: 'Total times the plugin was opened'
          },
          totalEvents: {
            title: 'Total Events',
            subtitle: 'Total interactions with the plugin'
          },
          emptyDash: '--'
        },
        usageOverTime: {
          title: 'Usage over time',
          seriesName: 'Events',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            title: 'Start using your plugin to see performance',
            subtitle: 'Here you will understand plugin usage over the months.'
          },
          noDomain: {
            title: 'Register a domain and start using to see performance',
            subtitle: 'Here you will understand your plugin usage over time'
          }
        },
        insights: {
          title: 'Trends and Insights',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            title: 'Wait for data collection',
            subtitle: 'We are collecting information to display trends and Insights.'
          },
          noDomain: {
            title: 'Register a domain and start using to see performance',
            subtitle: 'Here you will see trends and insights about your plugin usage'
          },
          dynamic: {
            topFeature: {
              prefix: 'The tool ',
              middle: ' was the most used, accumulating ',
              suffix: ' events in the period.'
            },
            peakUsage: {
              dayPrefix: 'The day ',
              monthPrefix: 'The month of ',
              middle: ' recorded the highest usage volume, reaching ',
              suffix: ' events.'
            },
            topProfile: {
              prefix: 'The navigation profile ',
              middle: ' led in number of activations, being triggered ',
              suffix: ' times.'
            }
          }
        },
        resourcesRanking: {
          title: 'Most used resources',
          error: {
            message: 'Failed to load information',
            retry: 'Try Again'
          },
          empty: {
            title: 'No usage data yet',
            subtitle: 'We are collecting information to display this data.'
          },
          noDomain: {
            title: 'Register a domain and start using to see performance',
            subtitle: 'Here you will see which plugin resources are most used by your users'
          },
          footer: 'Monthly result of all resources used.',
          events: 'events'
        },
        profiles: {
          title: 'Distribution of used profiles',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            title: 'No usage data yet',
            subtitle: 'We are collecting information to display this data.'
          },
          noDomain: {
            title: 'Register a domain and start using to see performance',
            subtitle: 'Here you will see how accessibility profiles are being used by your users'
          },
          footerLinkText: 'Learn how accessibility profiles work',
          iconAlt: 'Icon',
          arrowAlt: 'Arrow',
          tooltip: {
            eventsLabel: 'events'
          }
        },
        detailedUsage: {
          title: 'Detailed resource usage',
          filter: {
            all: 'All',
            categories: {
              content: 'Content',
              navigation: 'Navigation',
              colorAndScreen: 'Color and Screen'
            }
          },
          searchPlaceholder: 'Search',
          searchAlt: 'Search',
          subtitleAll: 'All',
          subtitleFiltered: 'Filtered Results',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            noData: 'No usage data available at the moment.',
            noResults: 'No resource found for this search.'
          },
          events: 'events'
        }
      },
      accountSettings: {
        title: 'Account settings',
        tabs: {
          account: 'Account',
          security: 'Security',
          billing: 'Billing & Plan',
          payment: 'Payment'
        },
        accountTab: {
          sectionTitle: 'Account type',
          saveButton: 'Save changes',
          cancelButton: 'Cancel'
        },
        deleteAccount: {
          title: 'Delete account',
          warningStrong: 'Are you sure you want to delete this account?',
          // warningText: removed — self-service deletion replaced by support request
          // warningText: 'Once you delete your account, there is no going back. Please be certain.',
          consequencesTitle: 'This action cannot be undone. When you delete your account:',
          consequence1: 'The accessibility widget immediately stops working on all your sites.',
          consequence2: 'Your subscription is cancelled and no further charges will be made.',
          consequence3: 'Domains, settings and invoice history are permanently removed.',
          // confirmLabel/button (legacy): removed along with the auto-confirmation checkbox
          // confirmLabel: 'Confirm deletion of my account',
          // button: 'Delete account',
          requestButton: 'Request deletion',
          modal: {
            title: 'Request account deletion',
            body: 'Deletion is handled by support to ensure security and compliance.',
            previewTitle: 'Data that will be sent to support:',
            fieldAccount: 'Account',
            fieldCompany: 'Company',
            fieldDocument: 'Document',
            fieldOwner: 'Owner',
            fieldEmail: 'Email',
            fieldPhone: 'Phone',
            fieldPlan: 'Plan',
            send: 'Send request',
            sending: 'Sending...',
            cancel: 'Cancel',
            successToast: 'Request sent. We will contact you within 3 business days.',
            errorToast: 'Could not send the request. Please try again shortly.',
            // Legacy (mailto): button replaced by backend call
            // emailSupport: 'Email support',
            // body1/body2/confirm (legacy): removed — modal now forwards to support
            // body1: 'This action is irreversible. All your data, domains and settings will be permanently deleted.',
            // body2: 'If you have an active plan, it will be cancelled immediately.',
            // confirm: 'Yes, delete my account',
          }
        },
        formBilling: {
          taxpayerTypeCorporate: 'Legal entity',
          taxpayerTypePersonal: 'Individual',
          companyDataTitle: 'Company details',
          personalDataTitle: 'Personal details',
          cpfLabel: 'Identification document (CPF)',
          cpfInvalid: 'Invalid CPF',
          cnpjLabel: 'Identification document (CNPJ)',
          cnpjInvalid: 'Invalid CNPJ',
          simplesLabel: 'Enrolled in Simples Nacional?',
          simplesYes: 'Yes',
          simplesNo: 'No',
          corporateName: 'Corporate name',
          fullName: 'Full name',
          fantasyName: 'Trade name',
          required: 'Required field',
          financialContact: 'Financial contact',
          responsibleName: 'Responsible name',
          responsibleNamePlaceholder: 'Responsible name',
          financialEmail: 'Email (that will receive the invoice)',
          emailInvalid: 'The email provided is invalid',
          phone: 'Phone',
          phoneInvalid: 'The phone number provided is invalid!',
          address: 'Address',
          zipCode: 'ZIP code',
          zipCodeInvalid: 'Invalid ZIP code',
          number: 'Number',
          complement: 'Complement',
          neighborhood: 'Neighborhood',
          state: 'State',
          city: 'City',
          toast: {
            loading: 'Saving request',
            success: 'Saved.',
            error: 'Error saving request, please try again later'
          }
        },
        limitePlan: {
          title: 'Plan limits',
          availableDomains: 'Available domains',
          pageviewsPerMonth: 'Pageviews per month'
        },
        securityTab: {
          title: 'Password',
          subtitle: 'Your password is managed by the authentication system. To change it, you will be redirected to a secure page.',
          passwordLabel: 'Password',
          changePasswordButton: 'Change password'
        },
        paymentTab: {
          title: 'Payment method',
          subtitle: 'Manage the card linked to your subscription.',
          cardLabel: 'Card',
          noCard: 'No card on file',
          nextBilling: 'Next billing date',
          changeCard: 'Change card',
          addCard: 'Add card',
          changeCardNotice: 'Clicking the button above will redirect you to a secure payment page. A $5.00 charge will be made to validate your card and then automatically refunded.',
          errorChangeCard: 'Error requesting card change. Please try again.',
          removeCard: 'Remove card',
          successRemoveCard: 'Card removed successfully.',
          errorRemoveCard: 'Error removing card. Please try again.',
          removeModal: {
            title: 'Remove card',
            body: 'Are you sure you want to remove the card on file? Automatic charges will stop working until a new card is provided.',
            confirm: 'Remove',
            cancel: 'Cancel'
          },
          modal: {
            title: 'Change payment method',
            titleAdd: 'Add payment method',
            body1: 'Your current card will be removed and you will continue adding the new card on the Asaas page, in a new tab.',
            body1Add: 'You will continue adding your card on the Asaas page, in a new tab.',
            body2: 'Validation charge: <b>$5.00</b>, automatically refunded.',
            body3: 'You will have no card on file until you complete the process. If you do not complete it, your plan may be cancelled at the next renewal.',
            body4: 'The refund may take <b>1 to 15 days</b> to appear on your statement.',
            confirm: 'Continue to payment',
            cancel: 'Cancel',
            close: 'Close',
            waitingTitle: 'Waiting for confirmation',
            waitingBody: 'Complete the new card registration on the page we opened in another tab. This window will update automatically once the card is confirmed.',
            reopen: 'Reopen payment page',
            successTitle: 'Card updated!',
            successBody: 'Your new card was successfully registered.',
            timeoutTitle: 'Process pending',
            timeoutBody: "We haven't received the new card confirmation yet. If you completed the registration, the data will be updated shortly."
          }
        },
        invoiceTable: {
          title: 'Invoice history',
          headers: {
            date: 'Date',
            invoiceNumber: 'Invoice number',
            plan: 'Plan',
            amount: 'Amount',
            status: 'Status'
          },
          statuses: {
            PENDING: 'Pending',
            PAID: 'Paid',
            PARTIALLY_PAID: 'Partially paid',
            OVERDUE: 'Overdue',
            CANCELED: 'Canceled',
            REFUNDED: 'Refunded'
          },
          filterAll: 'All statuses',
          actions: {
            download: 'Download invoice',
            view: 'View invoice'
          },
          empty: 'You have no charges.'
        }
      },
      firstFlow: {
        title: 'Hello {{name}}, welcome to Assistive! 🤩',
        subtitle: 'Ready to start your journey toward a more accessible digital world? Enter your company website to receive your installation code.',
        siteLabel: 'Website',
        siteTooltip: 'You can add more websites later.',
        sitePlaceholder: 'Your website (required)',
        siteInvalid: 'Invalid address! Use a format similar to these examples: https://assistive.com.br and http://assistive.com.br.',
        accountNameLabel: 'Account name',
        accountNameTooltip: 'Name to identify your account in Assistive. It can be your company name or your own name, for example.',
        accountNamePlaceholder: 'Your account',
        couponLabel: 'Promotional code',
        couponInsert: 'Insert',
        couponQuestion: 'Have a promotional code?',
        startTrial: 'Start free trial for {{days}} days',
        subscribePlan: 'Subscribe to monthly plan from {{price}}',
        toastSuccess: 'Data updated.',
        toastError: 'Error updating account',
        siteRequired: 'Please enter a valid website'
      },
      plans: {
        header: {
          title: 'Plans'
        },
        choose: {
          title: 'Choose the plan that best suits your business.',
          incompleteBanner: {
            title: 'You have a pending payment',
            description: 'Your {{planName}} plan subscription was created but payment has not been completed yet.',
            completePayment: 'Complete payment',
            chooseAnother: 'Choose another plan'
          },
          graceBanner: {
            title: 'Pending payment',
            description: 'Your {{planName}} plan has an open invoice. Confirm payment to continue with full access.',
            confirmPayment: 'Confirm payment',
            pendingPayment: 'Pending payment'
          },
          cancelledBanner: {
            revertCancellation: 'Revert cancellation'
          },
          pendingDowngrade: 'You already have a downgrade scheduled for this plan. The change will take effect at the next renewal.',
          pendingDowngradeBanner: {
            title: 'Downgrade scheduled',
            description: 'Your plan will be downgraded to {{planName}} at the next renewal. Cancel if you wish to remain on your current plan.',
            cancelBtn: 'Cancel downgrade',
            cancelSuccess: 'Downgrade cancelled. Your plan remains the same.',
            cancelError: 'Error cancelling downgrade. Please try again.',
            scheduledBtn: 'Downgrade scheduled'
          }
        },
        form: {
          backToPlans: 'choose plan',
          registration: {
            title: 'Registration',
            subtitle: 'Select the type of registration you want and fill in the fields to continue. All fields are required'
          },
          resume: {
            title: 'Summary',
            plan: 'Plan',
            billing: 'Billing',
            monthly: 'Monthly',
            totalValue: 'Total value',
            free: 'Free',
            enterprise: 'On Request',
            perMonth: '/month',
            finalize: 'Complete registration'
          },
          upgradeNotice: 'Since you already have an active plan, you will be charged the proportional amount for the remaining days of the current billing cycle.',
          downgradeNotice: 'You will continue to have access to your current plan until the end of the billing period. The new plan will take effect at the next renewal.',
          loading: {
            saving: 'Saving data...',
            generating: 'Generating payment link...',
            processing: 'Processing plan change...'
          },
          error: {
            checkoutIntegration: 'We could not process your payment. The CPF/CNPJ provided is invalid. Click the button below to correct your registration data.',
            generateLink: 'Could not generate payment link. Please try again later.',
            saveBilling: 'Error saving billing data',
            correctData: 'Correct registration data',
            tryAgain: 'Try again'
          },
          changePlan: {
            alreadyRequested: 'You have already requested a plan change today. The change will be applied at the end of the cycle.',
            pendingInvoice: 'There is a pending payment. Please complete the payment before changing your plan.',
            alreadySelected: 'Your plan is already the selected one.',
            notFound: 'Plan not found. Please try again or contact support.',
            invalidState: 'It is not possible to change the plan in the current state of your subscription.',
            genericError: 'Error changing plan'
          },
          confirmTrial: {
            notFound: 'Subscription or plan not found. Please try again or contact support.',
            alreadyConfirmed: 'Your subscription has already been confirmed.',
            genericError: 'Error confirming trial'
          },
          renewSubscription: {
            notFound: 'Subscription not found. Please try again or contact support.',
            alreadyActive: 'Your subscription is already active.',
            genericError: 'Error reactivating subscription'
          }
        },
        changeConfirm: {
          titleUpgrade: 'Confirm upgrade',
          titleDowngrade: 'Confirm downgrade',
          subtitleUpgrade: 'Review the details below and confirm the change to the higher plan.',
          subtitleDowngrade: 'Review the details below and confirm the change to the lower plan.',
          summary: 'Change summary',
          currentPlan: 'Current plan',
          newPlan: 'New plan',
          paymentMethod: 'Payment method',
          confirmUpgrade: 'Confirm upgrade',
          confirmDowngrade: 'Confirm downgrade',
          back: 'Go back'
        },
        upgradeCompleted: {
          title: 'Upgrade complete!',
          subtitle: 'Your plan has been successfully updated.',
          infoTitle: 'What happens now?',
          info1: 'The new plan is already active on your account.',
          info2: 'The proportional amount for the remaining period was automatically charged to your card.',
          summary: 'Change summary',
          previousPlan: 'Previous plan',
          newPlan: 'New plan',
          goToDashboard: 'Go to dashboard',
        },
        downgradeScheduled: {
          title: 'Downgrade scheduled',
          subtitle: 'Your current plan remains active until the end of the cycle.',
          infoTitle: 'What happens now?',
          info1: 'Your current plan continues normally until the renewal date.',
          info2: 'At the next renewal, the new plan will take effect automatically.',
          summary: 'Change summary',
          currentPlan: 'Current plan',
          newPlan: 'New plan',
          validUntil: 'Current plan valid until',
          goToDashboard: 'Go to dashboard',
        },
        paymentReady: {
          title: 'Registration complete!',
          subtitle: 'Almost there to activate your account.',
          securePayment: 'Secure payment with Asaas',
          securePaymentDesc: 'To ensure the security of your financial data, payment will be processed by Asaas, a financial institution specialized in online billing.',
          whatHappensNow: 'What happens now?',
          step1Title: 'You will be redirected',
          step1Desc: 'You will be directed to the secure Asaas page in a new tab.',
          step2Title: 'Complete the payment',
          step2Desc: 'Choose your payment method and complete your purchase with complete security.',
          step3Title: 'Automatic confirmation',
          step3Desc: 'After payment confirmation, your account will be activated automatically.',
          secureEnv: '100% secure environment',
          secureEnvDesc: 'Asaas uses 256-bit SSL encryption and follows the highest security standards in the market.',
          summary: 'Your subscription summary',
          plan: 'Plan',
          value: 'Amount',
          perMonth: '/month',
          recurringInfo: '✓ Monthly recurring billing • Cancel anytime',
          linkGeneratedOn: 'Payment link generated on',
          validUntil: 'Valid until',
          validFor: '(72h)',
          goToPayment: 'Go to secure payment',
          redirectNotice: 'You will be redirected to the Asaas website in a new tab.',
          returnNotice: 'After payment, you can close the tab and return to Assistive.',
          emailSent: 'We sent the payment link to',
          emailNotReceived: "Didn't receive it? Check your spam folder."
        }
      },
      billing: {
        success: {
          checkingStatus: 'Verifying payment...',
          checkingHint: 'Your account will be activated within 5 minutes.',
          checkingError: 'We could not confirm your payment.',
          checkingErrorHint: 'Your payment may have been processed anyway. Check your email or try again.',
          tryAgain: 'Try again',
          title: 'Payment confirmed!',
          subtitle: 'Your subscription has been activated successfully. Welcome to Assistive!',
          planActive: 'Your {{planName}} plan is active',
          planActiveDesc: 'Enjoy all Assistive features.',
          goToDashboard: 'Go to dashboard',
          summaryTitle: 'Confirmation summary',
          paymentStatus: 'Payment status',
          approved: 'Approved',
          dateTime: 'Date',
          plan: 'Plan',
          billing: 'Billing',
          monthly: 'Monthly',
          nextBilling: 'Next billing',
          amountPaid: 'Amount paid',
          whatNow: 'What happens now?',
          accessUnlocked: 'Access unlocked',
          accessUnlockedDesc: 'All features of your plan are now available.',
          autoRenewal: 'Automatic billing',
          autoRenewalDesc: 'You will be billed automatically every month.',
          invoice: 'Tax invoices',
          invoiceDesc: 'You will receive the invoice automatically by email.',
          orderSummary: 'Order summary',
          paidOn: 'Paid on',
          paymentApproved: 'Payment approved'
        },
        cancel: {
          title: 'Payment cancelled',
          subtitle: 'You cancelled the payment process.',
          whatNow: 'What to do now?',
          whatNowDesc: 'You can go back to the plans page and try again at any time.',
          tryAgain: 'Try again',
          orderSummary: 'Order summary',
          plan: 'Plan',
          billing: 'Billing',
          monthly: 'Monthly',
          paymentCancelled: 'Payment cancelled'
        },
        expired: {
          title: 'Payment link expired',
          subtitle: 'The payment link has expired. Generate a new one to continue.',
          whatNow: 'What to do now?',
          whatNowDesc: 'Generate a new payment link to continue with your plan subscription.',
          generateNewLink: 'Generate new link',
          orderSummary: 'Order summary',
          plan: 'Plan',
          billing: 'Billing',
          monthly: 'Monthly',
          linkExpired: 'Link expired'
        }
      },
      perfil: {
        title: 'Profile',
        userInfo: {
          title: 'User information',
          subtitle: 'Update your user information',
          fullName: 'Full name',
          nickname: 'Nickname',
          email: 'Email address',
          phone: 'Phone',
          required: 'This is a required field',
          saveButton: 'Save changes',
          changePasswordButton: 'Change password',
          toast: {
            loading: 'Updating information',
            success: 'Information updated',
            error: 'Error updating information'
          }
        },
        changePassword: {
          title: 'Change password',
          subtitle: 'The password must contain at least 8 characters.',
          oldPassword: 'Old password',
          newPassword: 'New password',
          required: 'This is a required field',
          minLength: 'The password must be at least 8 characters long.',
          button: 'Change password',
          toast: {
            error: 'Incorrect password',
            success: 'Changed successfully'
          }
        }
      },
      features: {
        tags: {
          conteudo: 'Content',
          navegacao: 'Navigation',
          corTela: 'Color and Screen',
          perfil: 'Profile'
        },
        init: 'Page views',
        toolbarT: 'Plugin opens',
        textsize1T: 'Larger Text 125%',
        textsize2T: 'Larger Text 140%',
        textsize3T: 'Larger Text 170%',
        textsize4T: 'Larger Text 200%',
        align_centerT: 'Center Alignment',
        align_justifyT: 'Justified Alignment',
        align_leftT: 'Left Alignment',
        align_rightT: 'Right Alignment',
        font_dyslexicT: 'Dyslexic Font',
        font_sansserifT: 'Sans Serif Font (Reading)',
        font_serifT: 'Serif Font',
        linespacing1T: 'Line Spacing 120%',
        linespacing2T: 'Line Spacing 140%',
        linespacing3T: 'Line Spacing 160%',
        charspacing1T: 'Letter Spacing 105%',
        charspacing2T: 'Letter Spacing 110%',
        charspacing3T: 'Letter Spacing 120%',
        imageT: 'No images',
        spkOpen: 'Site Reader',
        tooltipsT: 'Show Descriptions',
        imgdescT: 'Image Descriptions',
        soundT: 'No Sound',
        vlibrasT: 'Libras',
        semanticT: 'Semantic Dictionary',
        smartcontrast_defaultT: 'Minimum Text Contrast',
        smartcontrast_highT: 'Medium Text Contrast',
        smartcontrast_maxT: 'Maximum Text Contrast',
        contrast1T: 'Page Contrast 125%',
        contrast2T: 'Page Contrast 150%',
        contrast3T: 'Page Contrast 175%',
        contrast4T: 'Page Contrast 200%',
        contrast5T: 'Page Contrast 300%',
        saturation_dessaturateT: 'Faded Colors',
        saturation_highT: 'Intense Colors',
        saturation_lowT: 'Grayscale',
        colors_invertT: 'Invert Colors',
        colors_shift60T: 'Colors (Rotates 60°)',
        colors_shift120T: 'Colors (Rotates 120°)',
        colors_shift240T: 'Colors (Rotates 240°)',
        magnifyingT: 'Magnifying Glass',
        structclick: 'Page Structure',
        cursor_blackT: 'Black Cursor',
        cursor_blueT: 'Blue Cursor',
        cursor_redT: 'Red Cursor',
        cursor_whiteT: 'White Cursor',
        guideT: 'Reading Guide',
        rulerT: 'Reading Ruler',
        animationT: 'Stop Animations',
        highlight_allT: 'Highlight All Elements',
        highlight_btnT: 'Highlight Buttons',
        highlight_linkT: 'Highlight Links',
        highlight_titleT: 'Highlight Titles',
        focusT: 'Keyboard Focus Highlight',
        prof_p60_T: 'Navigation 60+',
        prof_seizures_T: 'Epilepsy Navigation',
        prof_vision_T: 'Low Vision Navigation',
        prof_adhd_T: 'ADHD Navigation',
        prof_dyslexic_T: 'Dyslexia Navigation',
        prof_cognitive_T: 'Cognitive assistance navigation',
        prof_motor_T: 'Keyboard navigation',
        prof_blind_T: 'Screen reader navigation (Blind)'
      }
    }
  }
